import React, { useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import FormatDate from "../Report/FormatDate";
import LoadingSpinner from "../Report/LoadingSpinner";
import { Button } from "primereact/button";
import Intersection from "../Plan/intersection";
import { FilterMatchMode } from "primereact/api";
import { Paginator } from "primereact/paginator";
import { imageTemplate } from "../Report/ProductInprogress";
import ModalFilterDelayProgress from "./ModalFilterDelayProgress";
import QR from "../Plan/QR";
import { formatDate } from "../Plan/ModalShowPlanLead";
import ModalShowPlanLead from "../Plan/ModalShowPlanLead";
import ModalShowCategoryMaterial from "../Plan/ModalShowCategoryMaterial";

const DelayProgress = ({ productInlateFactory, onPaginationChange }) => {
    const [dialogLocationVisible, setDialogLocationVisible] = useState(false);
    const [selectFactoryCode, setSelectFactoryCode] = useState(null);
    const [first, setFirst] = useState(0);
    const [rows, setRows] = useState(10);
    const [rowClick, setRowClick] = useState(true);
    const [selectedRow, setSelectedRow] = useState(null);
    const [selectedProducts, setSelectedProducts] = useState(null);
    const [openModal, setOpenModal] = useState(false);
    const [qrDetail, setQrDetail] = useState(null);
    const [visible3, setVisible3] = useState(false);
    const [visibleLead, setVisibleLead] = useState(false);
    const [selectedProductId, setSelectedProductId] = useState(null);
    const [visibleCategoryMaterial, setVisibleCategoryMaterial] =
        useState(false);

    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        "Building.buildingCode": {
            value: null,
            matchMode: FilterMatchMode.CONTAINS,
        },
        orderCode: { value: null, matchMode: FilterMatchMode.CONTAINS },
        categoryName: { value: null, matchMode: FilterMatchMode.CONTAINS },
        factoryCode: { value: null, matchMode: FilterMatchMode.CONTAINS },
        unit: { value: null, matchMode: FilterMatchMode.CONTAINS },
        productCode: { value: null, matchMode: FilterMatchMode.CONTAINS },
        quantity: { value: null, matchMode: FilterMatchMode.CONTAINS },
        intendFinishDate: { value: null, matchMode: FilterMatchMode.DATE_IS },
        status: { value: null, matchMode: FilterMatchMode.CONTAINS },
    });

    const handleTeamProgress = (rowData) => {
        setSelectFactoryCode(rowData.factoryCode);
        setDialogLocationVisible(true);
        setSelectedRow(rowData);
    };

    const onPageChange = (event) => {
        const newFirst = event.first;
        const newRows = event.rows;

        setFirst(newFirst);
        setRows(newRows);
        if (onPaginationChange) {
            onPaginationChange(newFirst, newRows);
        }
    };
    const handleDetailScanned = (detail) => {
        setQrDetail(detail);
    };

    const handleSelectionChange = (e) => {
        const selected = e.value || [];
        const currentPageItems = productInlateFactory?.data?.items || [];

        // Loại bỏ các phần tử thuộc trang hiện tại khỏi selectedProducts
        const filteredProducts =
            selectedProducts?.filter(
                (item) => !currentPageItems.some((row) => row.id === item.id)
            ) || [];

        // Gộp các phần tử không bị xóa với phần tử vừa chọn
        const updatedSelection = [...filteredProducts, ...selected];

        // Loại bỏ phần tử trùng lặp
        const uniqueSelection = Array.from(
            new Map(updatedSelection.map((item) => [item.id, item])).values()
        );

        setSelectedProducts(uniqueSelection);
    };
    const handleRowSelectLead = (rowData) => {
        setSelectedProductId(rowData.id);
        setVisibleLead(true);
    };
    const handleRowSelectCategoryMaterial = (rowData) => {
        setSelectedProductId(rowData.id);
        setVisibleCategoryMaterial(true);
    };
    return (
        <div className="border-round-lg p-3 bg-white">
            <div className="flex justify-content-between align-items-center mb-2">
                <p
                    style={{
                        color: "#5c5c5c",
                        fontWeight: "700",
                    }}
                >
                    Theo dõi vật tư
                </p>
                <Button
                    label="Lọc theo hạng mục"
                    onClick={() => setOpenModal(true)}
                ></Button>
            </div>
            {productInlateFactory && productInlateFactory.data ? (
                <div>
                    <DataTable
                        value={productInlateFactory?.data?.items}
                        rowClassName="custom-row-class-factory-inprogress"
                        size="small"
                        emptyMessage="Không có dữ liệu"
                        scrollable
                        scrollHeight="400px"
                        filters={filters}
                        onFilter={(e) => setFilters(e.filters)}
                        selectionMode="checkbox"
                        selection={selectedProducts || []}
                        onSelectionChange={handleSelectionChange}
                        dataKey="id"
                    >
                        <Column selectionMode="multiple"></Column>
                        <Column
                            header="STT"
                            body={(rowData, options) => (
                                <div className="text-center">
                                    {first + options.rowIndex + 1}
                                </div>
                            )}
                            style={{ width: "3%" }}
                            alignHeader={"center"}
                            align={"center"}
                        ></Column>
                        <Column
                            header="Tên công trình"
                            field="Building.name"
                            style={{ minWidth: "100px" }}
                            filter
                        />
                        <Column
                            header="Mã đơn hàng"
                            field="orderCode"
                            style={{ minWidth: "100px" }}
                            filter
                        />
                        <Column
                            header="Mã nhà máy"
                            field="factoryCode"
                            style={{ minWidth: "150px" }}
                            filter
                        />
                        <Column
                            header="Hạng mục"
                            field="categoryName"
                            style={{ lineHeight: "1.5", minWidth: "120px" }}
                            filter
                        />
                        <Column
                            header="Phân loại"
                            field="classify"
                            style={{ width: "5%", minWidth: "100px" }}
                            filterPlaceholder="Tìm kiếm mã ĐH..."
                        ></Column>
                        <Column
                            header="Chi tiết SP"
                            field="detail"
                            style={{ width: "5%", minWidth: "100px" }}
                        ></Column>
                        <Column
                            header="Thứ tự ưu tiên"
                            field="priority"
                            style={{ width: "8%", minWidth: "100px" }}
                        ></Column>
                        <Column
                            header="Hình ảnh"
                            style={{ minWidth: "100px" }}
                            body={imageTemplate}
                            alignHeader={"center"}
                            align={"center"}
                        ></Column>
                        <Column
                            header="SL"
                            field="quantity"
                            style={{ minWidth: "50px" }}
                        />
                        <Column
                            header="ĐVT"
                            field="unit"
                            style={{ minWidth: "50px" }}
                            filter
                        />
                        <Column
                            header="Mã sản phẩm"
                            field="productCode"
                            style={{ lineHeight: "1.5", minWidth: "120px" }}
                            filter
                        />

                        <Column
                            header="Tên vật tư chính"
                            field="materialName"
                            style={{ minWidth: "100px" }}
                            filter
                        />
                        <Column
                            header="Tên hạng mục gia công"
                            field="categoryMaterial"
                            style={{ minWidth: "100px" }}
                            filter
                            body={(rowData) =>
                                rowData.notMachining
                                    ? "Không cần hàng gia công"
                                    : rowData.categoryMaterial
                            }
                        />
                        <Column
                            header="Leadtime vật tư"
                            // field="categoryMaterial"
                            style={{ minWidth: "100px" }}
                            filter
                            body={(rowData) => (
                                <div className="text-center">
                                    <i
                                        className="pi pi-calendar cursor-pointer"
                                        onClick={() =>
                                            handleRowSelectLead(rowData)
                                        }
                                    ></i>
                                    <p>{formatDate(rowData.firstMaterial)}</p>
                                </div>
                            )}
                        />
                        <Column
                            header="Đã về"
                            field="materialCheck"
                            style={{ width: "8%", minWidth: "100px" }}
                            body={(rowData) =>
                                rowData?.materialCheck ? (
                                    <i className="pi pi-check text-red-500 text-xl font-semibold"></i>
                                ) : (
                                    <div></div>
                                )
                            }
                            align={"center"}
                        ></Column>
                        <Column
                            header="Leadtime hàng gia công"
                            // field="categoryMaterial"
                            style={{ minWidth: "100px" }}
                            filter
                            body={(rowData) => (
                                <div className="text-center">
                                    <i
                                        className="pi pi-calendar cursor-pointer"
                                        onClick={() =>
                                            handleRowSelectCategoryMaterial(
                                                rowData
                                            )
                                        }
                                    ></i>
                                    <p>{formatDate(rowData.firstMachining)}</p>
                                </div>
                            )}
                        />
                        <Column
                            header="Đã về"
                            field="machiningCheck"
                            style={{ width: "8%", minWidth: "100px" }}
                            body={(rowData) =>
                                rowData?.machiningCheck ? (
                                    <i className="pi pi-check text-red-500 text-xl font-semibold"></i>
                                ) : (
                                    <div></div>
                                )
                            }
                            align={"center"}
                        ></Column>
                        <Column
                            header="Ngày ra BOM"
                            field="endedDate"
                            body={(rowData) => (
                                <span>
                                    {FormatDate(rowData.bomProductionDate)}
                                </span>
                            )}
                            style={{ minWidth: "100px" }}
                            sortable
                            align="center"
                            alignHeader="center"
                        />
                        <Column
                            header="Định vị"
                            body={(rowData) => (
                                <div className="text-center">
                                    <Button
                                        onClick={() =>
                                            handleTeamProgress(rowData)
                                        }
                                        icon="pi pi-map-marker"
                                        rounded
                                        text
                                        severity="secondary"
                                        aria-label="Bookmark"
                                        style={{ color: "black" }}
                                    />
                                    <p>
                                        {rowData.status !==
                                            "Hoàn thành đúng tiến độ" &&
                                        rowData.status !==
                                            "Hoàn thành trễ tiến độ"
                                            ? rowData.teamWorking
                                            : "Đã giao"}
                                    </p>
                                    <p>
                                        {formatDate(
                                            rowData?.teamProductionDate
                                        )}
                                    </p>
                                </div>
                            )}
                            alignHeader={"center"}
                            align={"center"}
                            style={{ minWidth: "100px" }}
                        />
                        <Column
                            header="In QR"
                            body={(rowData) => (
                                <div className="text-center">
                                    <Button
                                        onClick={() => {
                                            setQrDetail(rowData);
                                            setVisible3(true);
                                        }}
                                        icon="pi pi-qrcode"
                                        rounded
                                        text
                                        severity="secondary"
                                        aria-label="QR"
                                        style={{ color: "black" }}
                                    />
                                </div>
                            )}
                            style={{ width: "8%", minWidth: "100px" }}
                            alignHeader={"center"}
                            align={"center"}
                        ></Column>
                    </DataTable>
                    <Paginator
                        first={first}
                        rows={rows}
                        totalRecords={productInlateFactory?.data?.totalItems}
                        rowsPerPageOptions={[10, 20, 30, 100, 200, 500]}
                        onPageChange={onPageChange}
                    />
                    {dialogLocationVisible && (
                        <Intersection
                            visible={dialogLocationVisible}
                            onHide={() => setDialogLocationVisible(false)}
                            factoryCode={selectFactoryCode}
                            rowData={selectedRow}
                        />
                    )}
                    <ModalFilterDelayProgress
                        visible={openModal}
                        onHide={() => setOpenModal(false)}
                        data={selectedProducts}
                    />
                    <QR
                        isShow={visible3}
                        hiden={() => setVisible3(false)}
                        detail={qrDetail}
                        onDetailScanned={handleDetailScanned}
                    />
                    <ModalShowPlanLead
                        isShow={visibleLead}
                        onHide={() => setVisibleLead(false)}
                        productId={selectedProductId}
                    />
                    <ModalShowCategoryMaterial
                        isShow={visibleCategoryMaterial}
                        onHide={() => setVisibleCategoryMaterial(false)}
                        productId={selectedProductId}
                    />
                </div>
            ) : (
                <LoadingSpinner />
            )}
        </div>
    );
};

export default DelayProgress;
